import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Auth from './pages/Auth';
import Account from './pages/Account';
import ResetPassword from './pages/ResetPassword';
import Products from './pages/Products';

function App() {
  // Simple routing based on URL path
  const path = window.location.pathname;
  
  if (path === '/signin') {
    return (
      <div className="App">
        <Navbar />
        <Auth />
      </div>
    );
  }
  
  if (path === '/reset-password') {
    return (
      <div className="App">
        <Navbar />
        <ResetPassword />
      </div>
    );
  }
  
  if (path === '/account') {
    return (
      <div className="App">
        <Navbar />
        <Account />
      </div>
    );
  }
  
  if (path === '/products') {
    return (
      <div className="App">
        <Navbar />
        <Products />
      </div>
    );
  }
  
  return (
    <div className="App">
      <Navbar />
      <Home />
    </div>
  );
}

export default App;

